module.exports = __webpack_public_path__ + "static/16-ff5edc4756289d7e931df0c20f9a2e99.jpg";